export default __webpack_public_path__ + "static/media/relatedTaskIcon.d9f2ebde.svg";